import { Component, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { IconComponent } from "../icon/icon.component";
import { RaskPopoverDirective } from "../../directives/popover/rask-popover.directive";
import { NgClass, NgTemplateOutlet, AsyncPipe } from "@angular/common";

@Component({
    selector: "rask-helpicon",
    templateUrl: "./../icon/icon.component.html",
    styleUrl: "./helpicon.component.scss",
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        RaskPopoverDirective,
        NgClass,
        NgTemplateOutlet,
        AsyncPipe
    ]
})
export class HelpiconComponent extends IconComponent implements OnInit {
    ngOnInit() {
        this.icon = "fa fa-question-circle";
        this.text = "Klicka för att visa hjälp";
    }

}
